// import React from 'react';

// interface HoverCardProps {
//     children: React.ReactNode;
//     content: React.ReactNode;
// }

// const HoverCard: React.FC<HoverCardProps> = ({ children, content }) => {
//     return (
//         <div className="group relative inline-block">
//             <div className="cursor-help">{children}</div>
//             <div className="opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 absolute z-50  bottom-full left-1/2 -translate-x-1/2 mb-2
//         sm:bottom-full sm:left-1/2 sm:-translate-x-1/2 sm:mb-2 
//         max-sm:bottom-0 max-sm:right-0 max-sm:left-auto max-sm:translate-x-0 max-sm:mb-0  
            
//             ">
//                 <div className="bg-[#120e20] border border-[#221757] rounded-lg shadow-lg p-4 min-w-[280px]">
//                     {content}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default HoverCard; 





import React, { useRef, useState, useEffect } from 'react';

interface HoverCardProps {
  children: React.ReactNode;
  content: React.ReactNode;
}

interface PositionState {
  top: boolean;
  left: boolean | null;
}

const HoverCard: React.FC<HoverCardProps> = ({ children, content }) => {
  const [position, setPosition] = useState<PositionState>({ top: false, left: null });
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updatePosition = () => {
      if (!containerRef.current || !contentRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const contentRect = contentRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;

      // Check if content would overflow bottom
      const wouldOverflowBottom = containerRect.bottom + contentRect.height > viewportHeight;
      // Check if content would overflow right
      const wouldOverflowRight = containerRect.right + contentRect.width / 2 > viewportWidth;
      // Check if content would overflow left
      const wouldOverflowLeft = containerRect.left - contentRect.width / 2 < 0;

      setPosition({
        top: wouldOverflowBottom,
        left: wouldOverflowRight ? true : wouldOverflowLeft ? false : null
      });
    };

    // Update position on hover
    const container = containerRef.current;
    if (container) {
      container.addEventListener('mouseenter', updatePosition);
      return () => container.removeEventListener('mouseenter', updatePosition);
    }
  }, []);

  return (
    <div ref={containerRef} className="relative inline-block group ">
      <div className="cursor-help">{children}</div>
      <div
        ref={contentRef}
        className={`
          invisible opacity-0 absolute z-50 min-w-[280px]
          group-hover:visible group-hover:opacity-100
          transition-all duration-300
          ${position.top ? 'bottom-full mb-2' : 'top-full '}
          ${position.left === true ? 'right-0' : 
            position.left === false ? 'left-0' : 
            'left-1/2 -translate-x-1/2'}
        `}
      >
        <div className="bg-[#120e20] border border-[#221757] rounded-lg shadow-lg p-4">
          {content}
        </div>

        {/* Arrow/Triangle indicator */}
        <div
          className={`
            absolute w-4 h-4 transform rotate-45
            bg-[#120e20] border border-[#221757]
            ${position.top ? 'bottom-[-8px] border-t-0 border-l-0' : 'top-[-8px] border-b-0 border-r-0'}
            ${position.left === true ? 'right-4' : 
              position.left === false ? 'left-4' : 
              'left-1/2 -translate-x-1/2'}
          `}
        />
      </div>
    </div>
  );
};

export default HoverCard;


